import currentLocale from 'utils/locale/currentLocale';

const formatNumber = (number: number) => number.toLocaleString(currentLocale);

export default formatNumber;
